import comillas from "../../images/testimonios/comillas.svg";
import "./Testimonio.css";

export const Testimonio = (props) => {
  return (
    <div id="testimonio">
      <div className="testimonio-box">
        <img
          className="comillas"
          src={comillas}
          alt="Comillas"
          style={{ marginBottom: "10px" }}
        />
        <p style={{ marginInline: "90px", fontSize: "medium" }}>{props.text}</p>
        <h1 style={{color: "#000000"}}>{props.name}</h1>
      </div>
    </div>
  );
};

export default Testimonio;
